import React, { useState } from "react";
import "./AdminCleanup.css";
import { Link } from "react-router-dom";
import { useAuth } from "react-oidc-context";
const AdminCleanup = () => {
  const { auth } = useAuth();
  const [selectedDate, setSelectedDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const API_URL = `https://${process.env.REACT_APP_API_KEY_CLEANUP}.execute-api.ap-south-1.amazonaws.com/default/BranchTransCleanup`;
  const handleDelete = async (mode) => {
    // Safety check for Delete All
    if (mode === "ALL" && confirmText !== "DELETE ALL DATA") {
      alert("Please type 'DELETE ALL DATA' to confirm this dangerous action.");
      return;
    }

    if (mode === "DATE" && !selectedDate) {
      alert("Please select a date first.");
      return;
    }

    const confirmMsg =
      mode === "ALL"
        ? "ARE YOU ABSOLUTELY SURE? This will wipe the entire transaction history."
        : `Delete all transactions for ${selectedDate}?`;

    if (!window.confirm(confirmMsg)) return;

    setLoading(true);
    try {
      const res = await fetch(API_URL, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth?.user?.access_token}`, // Pass the token for authentication
        },
        body: JSON.stringify({
          mode: mode, // "DATE" or "ALL"
          targetDate: selectedDate,
        }),
      });

      const result = await res.json();
      if (res.ok) {
        alert(`Success: ${result.deletedCount} transactions removed.`);
        setConfirmText("");
      } else {
        throw new Error(result.error);
      }
    } catch (err) {
      alert("Cleanup Error: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cleanup-container">
      <header className="cleanup-header">
        <div>
          <h1>Database Maintenance</h1>
          <p>Warning: Deletions are permanent and cannot be undone.</p>
        </div>
        <Link to="/">
          <button className="Branch-nav">Back to Dashboard</button>
        </Link>
      </header>

      <div className="cleanup-card">
        <h3>Option 1: Delete by Date</h3>
        <div className="input-group">
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
          <button
            className="btn-date-delete"
            disabled={loading}
            onClick={() => handleDelete("DATE")}
          >
            Delete Transactions for this Date
          </button>
        </div>
      </div>

      <div className="cleanup-card danger-zone">
        <h3>Option 2: Danger Zone</h3>
        <p>
          This will erase every single record in the branchTransaction table.
        </p>
        <input
          type="text"
          placeholder="Type 'DELETE ALL DATA' to enable"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
        />
        <button
          className="btn-nuke"
          disabled={loading || confirmText !== "DELETE ALL DATA"}
          onClick={() => handleDelete("ALL")}
        >
          {loading ? "Processing..." : "WIPE ALL TRANSACTIONS"}
        </button>
      </div>
    </div>
  );
};

export default AdminCleanup;
